export default "__VITE_ASSET__b853bbab__"